import axios from "axios";
import Cookie from 'js-cookie'
const request = axios.create({
    // baseURL:"",
    baseURL:"https://envvisual-backend.pawlk.com/api",
    timeout:60000
})

const errorHandler = (error)=>{
    if(error.response){
        const data = error.response.data

    }
    return Promise.reject(error)
}
request.interceptors.request.use(async config=>{
    var token = Cookie.get("token")
    // console.log(token)
    const xDate = new Date().getTime()
    Object.assign(config.headers,{
        "Authorization": token,
        // "x-data":xDate
    })
    return config
},errorHandler)
request.interceptors.response.use((response)=>{
    if(response.data.status == 401){
        return response
    }
    return response
},errorHandler)
export default request